import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import {
  ActionItemData,
  ActionItemId,
} from "../../types";
import { AdminHomeCustomIcon } from "../shared/adminHomeIcons";

type ActionItemsCardProps = {
  items: ActionItemData[];
  onActionClick?: (id: ActionItemId) => void;
};

const ActionItemsCard: React.FC<ActionItemsCardProps> = ({
  items,
  onActionClick,
}) => {
  return (
    <div className="admin-home-action-items">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={`admin-home-action-items__row${
            item.isStaticDisabled
              ? " admin-home-action-items__row--static-disabled"
              : ""
          }`}
          disabled={item.isStaticDisabled}
          onClick={() => {
            if (!item.isStaticDisabled) {
              onActionClick?.(item.id);
            }
          }}
        >
          <span
            className={`admin-home-action-items__icon admin-home-action-items__icon--${item.iconVariant}`}
          >
            {item.customIcon ? (
              <AdminHomeCustomIcon
                name={item.customIcon}
                width={20}
                height={20}
              />
            ) : item.icon ? (
              <Iconography icon={item.icon} size={IconographySizes.Small} />
            ) : null}
          </span>
          <span className="admin-home-action-items__text">
            <span className="admin-home-action-items__title">{item.title}</span>
            <span className="admin-home-action-items__subtitle">
              {item.subtitle}
            </span>
          </span>
          <span className="admin-home-action-items__plus" aria-hidden>
            <Iconography icon="plus" size={IconographySizes.Small} />
          </span>
        </button>
      ))}
    </div>
  );
};

export default ActionItemsCard;
